import { useFlags } from "flagsmith/react";

/** Flag mestre do redesign WOS (PED-12262). */
export const WOS_SHELL_FLAG_KEY = "wos-manager-shell";

/**
 * Decide se o shell novo (WOS) deve ser exibido.
 * Fonte: flag do Flagsmith, com override local via
 * `localStorage.setItem("wos-manager-shell", "true" | "false")`
 * para QA/desenvolvimento e testes e2e.
 */
export function useWosShell(): boolean {
  const flags = useFlags([WOS_SHELL_FLAG_KEY]);

  const override =
    typeof window !== "undefined"
      ? window.localStorage.getItem(WOS_SHELL_FLAG_KEY)
      : null;

  if (override === "true") return true;
  if (override === "false") return false;

  return true;
}
